import { render, staticRenderFns } from "./UserTribunalsUpdate.vue?vue&type=template&id=75786569"
import script from "./UserTribunalsUpdate.vue?vue&type=script&lang=js"
export * from "./UserTribunalsUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserTribunalsUpdate.vue?vue&type=style&index=0&id=75786569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports